// import Vue from 'vue'
// import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
//
// Vue.use(Router)
//
// export default new Router({
//   routes: [
//     {
//       path: '/',
//       name: 'HelloWorld',
//       component: HelloWorld
//     }
//   ]
// })

import Vue from 'vue'
import Router from 'vue-router'
import cookie from '../components/views/cookie.vue'
import sytk from '../components/views/sytk.vue'
import index from '../components/views/index.vue'
import Home from '../components/views/Home.vue'
import invasion from '../components/product/invasion'
import business from '../components/product/business'
import game from '../components/product/game'
import warfare from '../components/product/warfare'
import clashForDawn from '../components/product/clashForDawn'
import totalDestruction from '../components/product/totalDestruction'
import vampireEmpire from '../components/product/vampireEmpire'
import powerAndHonor from '../components/product/powerAndHonor'
import brutalAge from '../components/product/brutalAge'
import thisNew from '../components/product/thisNew'
import gameOfKings from '../components/product/gameOfKings'
import warOfSteel from '../components/product/warOfSteel'

Vue.use(Router)

export default new Router({
    // mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/home'
        },
        {
            path: '/home',
            component: index,
            children: [
                {
                    path: '/',
                    meta: {
                        title: '首页',
                        show: true
                    },
                    name: 'home',
                    component: Home,
                },

                {
                    path: '/cookie',
                    name: 'cookie',
                    component: cookie,
                },
                {
                    path: '/sytk',
                    name: 'sytk',
                    component: sytk,
                },
            ]
        },
        {
            path: '/product',
            component: index,
            children: [
                {
                    path: '/',
                    meta: {
                        title: 'invasion',
                        show: true
                    },
                    name: 'invasion',
                    component: invasion,
                },
                {
                    path: 'warfare',
                    meta: {
                        title: 'invasion',
                        show: true
                    },
                    name: 'warfare',
                    component: warfare,
                },
                {
                    path: 'clashForDawn',
                    meta: {
                        title: 'invasion',
                        show: true
                    },
                    name: 'clashForDawn',
                    component: clashForDawn,
                },
                {
                    path: 'totalDestruction',
                    meta: {
                        title: 'totalDestruction',
                        show: true
                    },
                    name: 'totalDestruction',
                    component: totalDestruction,
                },
                {
                    path: 'vampireEmpire',
                    meta: {
                        title: 'vampireEmpire',
                        show: true
                    },
                    name: 'vampireEmpire',
                    component: vampireEmpire,
                },
                //本地化
                {
                    path: 'powerAndHonor',
                    meta: {
                        title: 'powerAndHonor',
                        show: true
                    },
                    name: 'powerAndHonor',
                    component: powerAndHonor,
                }, {
                    path: 'brutalAge',
                    meta: {
                        title: 'brutalAge',
                        show: true
                    },
                    name: 'brutalAge',
                    component: brutalAge,
                }, {
                    path: 'thisNew',
                    meta: {
                        title: 'thisNew',
                        show: true
                    },
                    name: 'thisNew',
                    component: thisNew,
                }, {
                    path: 'gameOfKings',
                    meta: {
                        title: 'gameOfKings',
                        show: true
                    },
                    name: 'gameOfKings',
                    component: gameOfKings,
                }, {
                    path: 'warOfSteel',
                    meta: {
                        title: 'warOfSteel',
                        show: true
                    },
                    name: 'warOfSteel',
                    component: warOfSteel,
                },
            ]
        },
        //本地化业务
        {
            path: '/business',
            component: index,
            children: [
                {
                    path: '/',
                    meta: {
                        title: 'invasion',
                        show: true
                    },
                    name: 'invasion',
                    component: business,
                }
            ]
        },
        //本地化业务
        {
            path: '/game',
            component: index,
            children: [
                {
                    path: '/',
                    meta: {
                        title: 'game',
                        show: true
                    },
                    name: 'invasion',
                    component: game,
                }
            ]
        },
        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: index,
            children:[
                {
                    path:'/about',
                    component: () => import(/* webpackChunkName: "about" */ '../components/views/About.vue')
                }
            ]
        },

    ]
})




// WEBPACK FOOTER //
// ./src/router/index.js